import { Component } from '@angular/core';

@Component({
  selector: 'hip-full-screen-loader',
  templateUrl: './full-screen-loader.component.html',
  styleUrls: ['./full-screen-loader.component.scss'],
})
export class FullScreenLoaderComponent {}
